import { HttpEvent, HttpEventType } from '@angular/common/http';
import * as FileSaver from 'file-saver';

export const DOWNLOAD_DONE_VISIBILITY_DURATION = 1200;

enum ProgressMode {
    Query = 'query',
    Indeterminate = 'indeterminate',
    Determinate = 'determinate',
}

export class Progress {
    mode: ProgressMode | null;
    value: number;

    constructor() {
        this.reset();
    }

    reset() {
        this.mode = null;
        this.value = 0;
    }

    query() {
        this.mode = ProgressMode.Query;
        this.value = 0;
    }

    indeterminate() {
        this.mode = ProgressMode.Indeterminate;
        this.value = 0;
    }

    determinate(value: number, total: number = 100) {
        this.mode = ProgressMode.Determinate;
        this.value = Math.round((value / total) * 100);
    }

    isDone(): boolean {
        return this.mode === ProgressMode.Determinate && this.value === 100;
    }

    isBusy(): boolean {
        return this.mode !== null;
    }
}

export abstract class DownloadService {
    progress: Progress = new Progress();

    static saveFile(data: Blob, filename: string, fileType?: string) {
        const options: FilePropertyBag = { ...(fileType ? { type: fileType } : {}) };
        FileSaver.saveAs(new File([data], filename, options));
    }

    handleEvent(event: HttpEvent<Blob>, filename, fileType: string = '') {
        switch (event.type) {
            case HttpEventType.Sent:
            case HttpEventType.ResponseHeader:
                this.progress.indeterminate();
                break;
            case HttpEventType.DownloadProgress:
                this.progress.determinate(event.loaded, event.total);
                break;
            case HttpEventType.Response:
                this.progress.determinate(100);
                // detectChanges is necessary because parent components might be OnPush
                setTimeout(() => {
                    this.progress.reset();
                }, DOWNLOAD_DONE_VISIBILITY_DURATION);
                DownloadService.saveFile(event.body!, filename, fileType);
                break;
        }
    }

    error() {
        this.progress.reset();
    }
}
